"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapToSolAdmin = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const constants_1 = require("../../constants");
const common_1 = require("../../../common");
const spl_stake_pool_1 = require("@solana/spl-stake-pool");
const spl_token_1 = require("@solana/spl-token");
const swapToSolAdmin = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, accounts, args, sendTxn, }) {
    const instructions = [];
    const poolTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, constants_1.BANX_SOL_MINT);
    const signers = [];
    instructions.push((0, spl_token_1.createApproveInstruction)(poolTokenAccount, accounts.userPubkey, accounts.userPubkey, Number(args.amount)));
    const [withdrawAuthority] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.BANX_SOL_POOL.toBuffer(), Buffer.from('withdraw')], constants_1.SANCTUM_POOL_PROGRAM);
    const withdrawTransaction = spl_stake_pool_1.StakePoolInstruction.withdrawSol({
        stakePool: constants_1.BANX_SOL_POOL,
        withdrawAuthority: withdrawAuthority,
        sourceTransferAuthority: accounts.userPubkey,
        sourcePoolAccount: poolTokenAccount,
        reserveStake: constants_1.RESERVE_STAKE_BANX_SOL,
        solWithdrawAuthority: accounts.userPubkey,
        destinationSystemAccount: accounts.userPubkey,
        managerFeeAccount: constants_1.MANAGER_BANX_SOL_FEE,
        poolMint: constants_1.BANX_SOL_MINT,
        poolTokens: Number(args.amount),
    });
    withdrawTransaction.programId = constants_1.SANCTUM_POOL_PROGRAM;
    instructions.push(withdrawTransaction);
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    yield sendTxn(transaction, signers);
    return {
        instructions,
        signers,
    };
});
exports.swapToSolAdmin = swapToSolAdmin;
